import { TextField, TextFieldProps } from './text-field';
import { FieldValues, Path } from 'react-hook-form';

export interface RegNumberFieldProps<T extends FieldValues = FieldValues> extends Omit<TextFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const RegNumberField = <T extends FieldValues = FieldValues>({
  label = 'Car registration number',
  required,
  name = 'regNo' as Path<T>,
  ...rest
}: RegNumberFieldProps<T>) => {
  return <TextField name={name} label={label} required={required} {...rest} />;
};
